import React from 'react';

const gradeLabels = {
  'middle-school': 'Middle School (Class of 2030+)',
  'freshman': 'Freshman (Class of 2029)',
  'sophomore': 'Sophomore (Class of 2028)',
  'junior': 'Junior (Class of 2027)',
  'senior': 'Senior (Class of 2026)'
};

function StudentProfile({ formData, isOpen, onToggle }) {
  if (!formData) return null;

  return (
    <section id="profile-section" className="report-section">
      <div className="section-header" onClick={onToggle}>
        <h2>Student Profile</h2>
        <button className="accordion-toggle">
          {isOpen ? '▼' : '▶'}
        </button>
      </div>

      {isOpen && (
        <div className="section-content">
          <div className="profile-grid">
            <div className="profile-item">
              <span className="profile-label">Grade Level:</span>
              <span className="profile-value">{gradeLabels[formData.grade]}</span>
            </div>
            <div className="profile-item">
              <span className="profile-label">GPA:</span>
              <span className="profile-value">{formData.gpa} / 4.0</span>
            </div>

            {/* Test Scores */}
            {formData.satScore && (
              <div className="profile-item">
                <span className="profile-label">SAT Score:</span>
                <span className="profile-value">{formData.satScore}</span>
              </div>
            )}
            {formData.actScore && (
              <div className="profile-item">
                <span className="profile-label">ACT Score:</span>
                <span className="profile-value">{formData.actScore}</span>
              </div>
            )}
            {formData.psatScore && (
              <div className="profile-item">
                <span className="profile-label">PSAT Score:</span>
                <span className="profile-value">{formData.psatScore}</span>
              </div>
            )}
          </div>

          {/* Intended Majors */}
          {formData.knowsMajor === 'yes' && formData.majors.length > 0 && (
            <>
              <h3 style={{ marginTop: '2rem', marginBottom: '1rem' }}>Intended Majors</h3>
              <div className="majors-list">
                {formData.majors.map((major, index) => (
                  <div key={index} className="major-chip-display">
                    {major}
                  </div>
                ))}
              </div>
            </>
          )}

          {formData.knowsMajor === 'no' && (
            <>
              <h3 style={{ marginTop: '2rem', marginBottom: '1rem' }}>Academic Interests</h3>
              <p className="exploring-message">
                Still exploring career options - this is perfectly normal! Many successful students
                discover their passions during their first year of college.
              </p>
            </>
          )}
        </div>
      )}
    </section>
  );
}

export default StudentProfile;